function escapeRegex(input: string): string {
  return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function replaceWholePhrase(input: string, source: string, target: string): string {
  const startsWithWordCharacter = /^[\p{L}\p{N}]/u.test(source);
  const endsWithWordCharacter = /[\p{L}\p{N}]$/u.test(source);
  const leadingBoundary = startsWithWordCharacter ? "(^|[^\\p{L}\\p{N}])" : "()";
  const trailingBoundary = endsWithWordCharacter ? "(?=$|[^\\p{L}\\p{N}])" : "";
  const pattern = new RegExp(`${leadingBoundary}${escapeRegex(source)}${trailingBoundary}`, "gu");

  return input.replace(pattern, (_match, prefix: string) => `${prefix}${target}`);
}
